<span (click)="buttonClicked($event)">
  <button
    [id]="id"
    [class]="'unity-button ' + _classes + (_loading ? ' loading' : '')"
    [type]="type"
    [disabled]="disabled"
  >
    <!-- <i
    id="loading"
    *ngIf="_loading"
    [class]="'fa fa-fw ' + (_loading ? 'fa-ep-loading' : ' fa-stopspin')"
    [class.fa-spin]="_loading"
    style="position: absolute; align-items: center; justify-content: center"
  >
  </i> -->
    <ng-content></ng-content>
  </button>
</span>
